import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchRecentAudioBlocks,
  fetchRecentMarkers,
} from "../../../action_managers/audio_management";
import "./audio-management.scss";
import { Col, Grid, Row } from "react-bootstrap";
import Divider from "../../lib/divider";
import RightChevron from "../../../icons/forward-chevron.svg";
import { Link } from "react-router-dom";
import BlocksTable from "../audio_blocks/audio_blocks_table";
import MarkersTable from "./markers_table";
import get from "lodash/get";

class AudioManagementPage extends Component {
  componentDidMount() {
    this.props.fetchRecentMarkers();
    this.props.fetchRecentAudioBlocks(this.props.user.uuid);
  }

  render() {
    return (
      <div className="page-wrapper">
        <Grid fluid>
          <Row>
            <Col className="page-header-margin--top">
              <h1>Dynamic Insertion</h1>
              <Divider smallMargin />
            </Col>
          </Row>
          <Row>
            <Link className="no-style-link" to="/insertion-points">
              <Col
                className="audio-management__gray-box"
                xs={12}
                md={6}
                style={{ marginRight: "2%" }}>
                <h3 className="no-margin">Insertion Points</h3>
                <div className="padding-right--large">
                  View and create points of insertion for audio blocks across your episodes
                </div>
                <img src={RightChevron} alt="right-chevron" />
              </Col>
            </Link>
            <Link className="no-style-link" to="/audio-blocks">
              <Col className="audio-management__gray-box" xs={12} md={6}>
                <h3 className="no-margin">Audio Blocks</h3>
                <div className="padding-right--large">
                  Upload and manage your intros, updates, advertisements, and cross-promotion audio
                  clips
                </div>
                <img src={RightChevron} alt="right-chevron" />
              </Col>
            </Link>
          </Row>

          <Row className="audio-management__recently-added">
            <Col>
              <div>
                <h3 className="no-margin">Recently Created Blocks</h3>
                <Divider className="no-margin margin-top--small" />
                <BlocksTable audioBlocks={this.props.recentAudioBlocks} />
              </div>
              <div className="recent-markers">
                <h3 className="no-margin">Recently Created Insertion Points</h3>
                <MarkersTable markers={this.props.recentMarkers} showHeader={true} />
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default connect(
  state => {
    const markerByUUID = get(state, "markers.markers", []);
    const audioBlockByUUID = get(state, "audioBlocks.audioBlocks", []);
    const recentMarkerUUIDs = get(state, "markers.recentMarkerUUIDs", []);
    const recentAudioBlockUUIDs = get(state, "audioBlocks.recentAudioBlockUUIDs", []);

    const recentAudioBlocks = recentAudioBlockUUIDs.map(uuid => audioBlockByUUID[uuid]);
    const recentMarkers = recentMarkerUUIDs.map(uuid => markerByUUID[uuid]);

    return {
      user: state.user.user,
      recentAudioBlocks,
      recentMarkers,
    };
  },
  {
    fetchRecentMarkers,
    fetchRecentAudioBlocks,
  }
)(AudioManagementPage);
